/**
 * 
 * @description 导入所有 vuex 模块，自动加入namespaced:true，用于解决vuex命名冲突，请勿修改。
 */

import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
const files = require.context('./modules', false, /\.js$/)
const modules = {}

files.keys().forEach((key) => {
  modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
})
Object.keys(modules).forEach((key) => {
  modules[key]['namespaced'] = true
})
Vue.filter('dateFormat', function (originVal) {
  if (originVal) {
    const dt = new Date(originVal)

    const y = dt.getFullYear()
    const m = (dt.getMonth() + 1 + '').padStart(2, '0')
    const d = (dt.getDate() + '').padStart(2, '0')

    const hh = (dt.getHours() + '').padStart(2, '0')
    const mm = (dt.getMinutes() + '').padStart(2, '0')
    const ss = (dt.getSeconds() + '').padStart(2, '0')

    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
  }
})
const store = new Vuex.Store({
  modules,
  state: {
    collapse: false
  },
  actions: {
    actionChange(ctx, collapse) {
      ctx.commit("mutatiosChange", collapse);
    }
  },
  mutations: {
    mutatiosChange(state, collapse) {
      state.collapse = collapse;
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js